import initProductScript from '../Scripts/product.js';
import initContactScript from '../Scripts/contact.js';

// Definicja funkcji
function sanitizeFileName(name)
{
	return name.replace(/[^a-z0-9_\-\.]/gi, "_");
}

function getExtensionFromUrl(url)
{
	var match = url.match(/\.\w+$/);
	return match ? match[ 0 ] : ".pdf";
}
function obliczPredkoscWiatru(strefaWiatru, kategoriaTerenu, wysokosc)
{
	// Wybór odpowiedniej tabeli na podstawie strefy wiatru
	let tabela;
	if (strefaWiatru == 1)
	{
		tabela = tabela1;
	}
	else if (strefaWiatru == 2)
	{
		tabela = tabela2;
	}
	else if (strefaWiatru == 3)
	{
		tabela = tabela3;
	}
	else
	{
		return "Nieprawidłowa strefa wiatru";
	}

	// Wybór odpowiedniej kolumny na podstawie kategorii terenu
	let kolumna;
	if (kategoriaTerenu == 0)
	{
		kolumna = 0;
	}
	else if (kategoriaTerenu == 1)
	{
		kolumna = 1;
	}
	else if (kategoriaTerenu == 2)
	{
		kolumna = 2;
	}
	else if (kategoriaTerenu == 3)
	{
		kolumna = 3;
	}
	else if (kategoriaTerenu == 4)
	{
		kolumna = 4;
	}
	else
	{
		return "Nieprawidłowa kategoria terenu";
	}

	// Wybór odpowiedniego wiersza na podstawie wysokości nad poziomem gruntu
	let wiersz;
	if (wysokosc == 0)
	{
		wiersz = 0;
	}
	else if (wysokosc == 5)
	{
		wiersz = 1;
	}
	else if (wysokosc == 10)
	{
		wiersz = 2;
	}
	else if (wysokosc == 15)
	{
		wiersz = 3;
	}
	else if (wysokosc == 20)
	{
		wiersz = 4;
	}
	else if (wysokosc == 25)
	{
		wiersz = 5;
	}
	else if (wysokosc == 30)
	{
		wiersz = 6;
	}
	else if (wysokosc == 35)
	{
		wiersz = 7;
	}
	else if (wysokosc == 40)
	{
		wiersz = 8;
	}
	else if (wysokosc == 45)
	{
		wiersz = 9;
	}
	else if (wysokosc == 50)
	{
		wiersz = 10;
	}
	else if (wysokosc == 60)
	{
		wiersz = 11;
	}
	else if (wysokosc == 70)
	{
		wiersz = 12;
	}
	else if (wysokosc == 80)
	{
		wiersz = 13;
	}
	else if (wysokosc == 90)
	{
		wiersz = 14;
	}
	else if (wysokosc == 100)
	{
		wiersz = 15;
	}
	else
	{
		return "Nieprawidłowa wysokość nad poziomem gruntu";
	}

	// Zwrócenie wartości z tabeli
	return tabela[ wiersz ][ kolumna ];
}

let tabela1 = [
	// Strefa I i III (0 - 300 m n.p.m.)
	//["kategoria 0, I, II, III, IV"]
	[ 104, 98, 84, 74, 64 ],		// 0m //zmiana
	[ 119, 114, 102, 92, 81 ],	// 5m //zmiana
	[ 126, 122, 110, 100, 89 ],	// 10m
	[ 131, 127, 116, 106, 95 ],	// 15m
	[ 134, 130, 120, 110, 99 ],	// 20m
	[ 136, 133, 123, 113, 102 ],	// 25m
	[ 138, 135, 126, 116, 105 ],	// 30m
	[ 140, 137, 128, 118, 107 ],	// 35m
	[ 142, 139, 130, 120, 109 ],	// 40m
	[ 143, 141, 132, 122, 111 ],	// 45m
	[ 145, 142, 134, 124, 113 ],	// 50m
	[ 147, 144, 137, 127, 116 ],	// 60m
	[ 149, 147, 139, 129, 118 ],	// 70m
	[ 150, 148, 142, 131, 121 ],	// 80m
	[ 152, 150, 144, 134, 123 ],	// 90m
	[ 153, 152, 146, 135, 125 ] ];	// 100m

let tabela2 = [
	// Strefa II (0 - 300 m n.p.m.)
	//["kategoria 0, I, II, III, IV"]
	[ 123, 116, 99, 88, 76 ],		//zmiana
	[ 141, 135, 120, 109, 95 ],	//zmiana
	[ 149, 144, 131, 119, 105 ],
	[ 154, 150, 137, 125, 112 ],
	[ 158, 154, 142, 130, 117 ],
	[ 161, 157, 146, 134, 120 ],
	[ 164, 160, 149, 137, 124 ],
	[ 166, 162, 152, 140, 127 ],
	[ 168, 164, 154, 142, 129 ],
	[ 170, 166, 156, 144, 131 ],
	[ 171, 168, 158, 146, 133 ],
	[ 174, 171, 162, 150, 137 ],
	[ 176, 173, 165, 153, 140 ],
	[ 178, 176, 168, 156, 143 ],
	[ 180, 178, 170, 158, 145 ],
	[ 181, 179, 172, 160, 147 ] ];

let tabela3 = [
	// Strefa III (300 - 500 m n.p.m.)
	//["kategoria 0, I, II, III, IV"]
	[ "x", 110, 94, 83, 71 ],		//zmiana
	[ "x", 128, 114, 103, 90 ],	//zmiana
	[ "x", 136, 124, 112, 100 ],
	[ "x", 142, 130, 118, 106 ],
	[ "x", 146, 134, 123, 110 ],
	[ "x", 149, 138, 127, 114 ],
	[ "x", 151, 141, 130, 117 ],
	[ "x", 154, 144, 132, 120 ],
	[ "x", 156, 146, 135, 122 ],
	[ "x", 157, 148, 137, 124 ],
	[ "x", 159, 150, 138, 126 ],
	[ "x", 162, 153, 142, 129 ],
	[ "x", 164, 156, 145, 132 ],
	[ "x", 166, 159, 147, 135 ],
	[ "x", 168, 161, 149, 137 ],
	[ "x", 170, 163, 152, 139 ] ];



jQuery(function()
{
	jQuery(".mast_params_wrapper > div:first-child").addClass('active');
	jQuery("#first-mast").addClass('active');
	let windResistance = [];
	jQuery('.mast_img').each(function()
	{
		let mastIndex = jQuery(this).index();
		let mastResistance = jQuery(this).attr('data-wind-resistance');
		let mastHeight = jQuery(this).attr('data-height');
		let mastType = jQuery(this).attr('data-mast');
		let mastMaterial = jQuery(this).attr('data-material');
		windResistance[ mastIndex ] = [ mastResistance, mastHeight, mastType, mastMaterial ];
	});
	windResistance.sort(function(a, b)
	{
		return a[ 0 ] - b[ 0 ];
	});

	jQuery('#choose-wind-zone').ddslick({
		width: 500,
		background: "#fff",
		selectText: "Strefa wiatrowa",
		onSelected: function(selectedData)
		{
			jQuery(".mast_params_wrapper").removeClass('active');
			if (selectedData.selectedData.value != '')
			{
				jQuery(".choose-type-label").removeClass('active');
				jQuery("#wind-zone-label").addClass('active');
				jQuery("#terrain-type-label").addClass('active');
				/*start teren*/
				jQuery('#choose-terrain-type').ddslick({
					width: 500,
					background: "#fff",
					selectText: "Kategoria terenu",
					defaultSelectedIndex: 0,
					onSelected: function(selectedData)
					{
						jQuery(".mast_params_wrapper").removeClass('active');
						if (selectedData.selectedData.value != '')
						{
							jQuery(".choose-type-label").removeClass('active');
							jQuery("#wind-zone-label").addClass('active');
							jQuery("#terrain-type-label").addClass('active');
							jQuery("#height-label").addClass('active');
							/*start hc*/
							jQuery('#choose-height').ddslick({
								width: 500,
								background: "#fff",
								selectText: "Wysokość Hc nad poziomem gruntu",
								defaultSelectedIndex: 0,
								onSelected: function(selectedData)
								{
									jQuery(".mast_params_wrapper").removeClass('active');
									if (selectedData.selectedData.value != '')
									{
										jQuery(".choose-type-label").removeClass('active');
										jQuery("#wind-zone-label").addClass('active');
										jQuery("#terrain-type-label").addClass('active');
										jQuery("#height-label").addClass('active');
										jQuery("#material-label").addClass('active');
										/*start material*/
										jQuery('#choose-mast-material').ddslick({
											width: 500,
											background: "#fff",
											selectText: "Wersja materiałowa",
											defaultSelectedIndex: 0,
											onSelected: function(selectedData)
											{
												jQuery(".mast_params_wrapper").removeClass('active');
												if (selectedData.selectedData.value != '')
												{
													jQuery(".choose-type-label").removeClass('active');
													jQuery("#wind-zone-label").addClass('active');
													jQuery("#terrain-type-label").addClass('active');
													jQuery("#height-label").addClass('active');
													jQuery("#material-label").addClass('active');
													jQuery("#mast-type-label").addClass('active');
													let wersjaMaterialowa = jQuery('#choose-mast-material .dd-selected-value').val();
													var index = windResistance.findIndex(function(number)
													{
														return number[ 3 ] == wersjaMaterialowa;
													});
													if (index != -1)
													{
														var indexes = [];
														for (let i = 0; i < windResistance.length - 1; i++)
														{
															if (windResistance[ i ][ 3 ] == wersjaMaterialowa)
															{
																indexes.push(windResistance[ i ][ 2 ]);
															}
														}
														/*start type*/
														jQuery('#choose-mast-type').ddslick({
															width: 500,
															background: "#fff",
															selectText: "Rodzaj masztu",
															defaultSelectedIndex: 0,
															onSelected: function(selectedData)
															{
																jQuery(".mast_params_wrapper").removeClass('active');
																if (selectedData.selectedData.value != '')
																{
																	jQuery(".choose-type-label").removeClass('active');
																	jQuery("#wind-zone-label").addClass('active');
																	jQuery("#terrain-type-label").addClass('active');
																	jQuery("#height-label").addClass('active');
																	jQuery("#material-label").addClass('active');
																	jQuery("#mast-type-label").addClass('active');
																	jQuery("#mast-height-label").addClass('active');
																	jQuery(".mast_img").removeClass('active');
																	jQuery("#first-mast").addClass('active');
																	let rodzajMasztu = jQuery('#choose-mast-type .dd-selected-value').val();
																	var index = windResistance.findIndex(function(number)
																	{
																		return number[ 2 ] == rodzajMasztu;
																	});
																	if (index != -1)
																	{
																		var indexes = [];
																		for (let i = 0; i < windResistance.length - 1; i++)
																		{
																			if (windResistance[ i ][ 3 ] == wersjaMaterialowa && windResistance[ i ][ 2 ] == rodzajMasztu)
																			{
																				indexes.push(windResistance[ i ][ 1 ]);
																			}
																		}
																		/*start mast height*/
																		jQuery('#choose-mast-height').ddslick({
																			width: 500,
																			background: "#fff",
																			defaultSelectedIndex: 0,
																			selectText: "Wysokość masztu",
																			onSelected: function(selectedData)
																			{
																				if (selectedData.selectedData.value != '')
																				{
																					let rodzajMasztu = jQuery('#choose-mast-type .dd-selected-value').val();
																					let wysokoscMasztu = selectedData.selectedData.value;
																					let wysokosc = jQuery('#choose-height .dd-selected-value').val();
																					let strefaWiatru = jQuery('#choose-wind-zone .dd-selected-value').val();
																					let kategoriaTerenu = jQuery('#choose-terrain-type .dd-selected-value').val();
																					let predkoscWiatru = obliczPredkoscWiatru(strefaWiatru, kategoriaTerenu, wysokosc);
																					if (predkoscWiatru != 'x')
																					{
																						jQuery(".mast_params_wrapper").addClass('active');
																						jQuery("#mast_density").html("<strong>Maksymalna prędkość wiatru dla wybranej lokalizacji wynosi: </strong>" + predkoscWiatru + "km/h");
																						var index = windResistance.findIndex(function(number)
																						{
																							return number[ 0 ] >= predkoscWiatru && number[ 1 ] == wysokoscMasztu && number[ 2 ] == rodzajMasztu && number[ 3 ] == wersjaMaterialowa;
																						});
																						console.log(index);
																						if (index != -1)
																						{
																							jQuery(".mast_img").removeClass('active');
																							jQuery("#mast-" + index).addClass('active');
																						}
																						else
																						{
																							jQuery(".mast_img").removeClass('active');
																							jQuery("#no-mast").addClass('active');
																						}
																					}
																					else
																					{
																						jQuery("#mast_density").text('Maszt o podanych parametrach jest niedostępny');
																						jQuery(".mast_img").removeClass('active');
																						jQuery("#no-mast").addClass('active');
																					}
																				}
																				else
																				{
																					jQuery(".mast_img").removeClass('active');
																					jQuery("#first-mast").addClass('active');
																				}


																			}
																		});
																		/*end mast height*/
																		jQuery("#choose-mast-height").ddslick('select', { index: 0 });
																		jQuery("#choose-mast-height .dd-options > li").hide();
																		jQuery("#choose-mast-height .dd-options > li:first-child").show();
																		for (let j = 0; j < indexes.length; j++)
																		{
																			let li = jQuery("#choose-mast-height .dd-options .dd-option-value[value='" + indexes[ j ] + "']");
																			jQuery(li).parent().parent().show();
																		}
																	}
																	else
																	{
																		jQuery(".choose-type-label").removeClass('active');
																		jQuery("#wind-zone-label").addClass('active');
																		jQuery("#terrain-type-label").addClass('active');
																		jQuery("#height-label").addClass('active');
																		jQuery("#material-label").addClass('active');
																		jQuery("#mast-type-label").addClass('active');
																		jQuery("#mast-height-label").addClass('active');
																		jQuery(".mast_img").removeClass('active');
																		jQuery("#first-mast").addClass('active');
																	}
																}
																else
																{
																	jQuery(".choose-type-label").removeClass('active');
																	jQuery("#wind-zone-label").addClass('active');
																	jQuery("#terrain-type-label").addClass('active');
																	jQuery("#height-label").addClass('active');
																	jQuery("#material-label").addClass('active');
																	jQuery("#mast-type-label").addClass('active');
																	jQuery(".mast_img").removeClass('active');
																	jQuery("#first-mast").addClass('active');
																}
															}
														});
														jQuery("#choose-mast-type").ddslick('select', { index: 0 });
														/*end type*/
														jQuery("#choose-mast-type .dd-options > li").hide();
														jQuery("#choose-mast-type .dd-options > li:first-child").show();
														for (let j = 0; j < indexes.length; j++)
														{
															let li = jQuery("#choose-mast-type .dd-options .dd-option-value[value='" + indexes[ j ] + "']");
															jQuery(li).parent().parent().show();
														}
													}
													else
													{
														jQuery(".choose-type-label").removeClass('active');
														jQuery("#wind-zone-label").addClass('active');
														jQuery("#terrain-type-label").addClass('active');
														jQuery("#height-label").addClass('active');
														jQuery("#material-label").addClass('active');
														jQuery(".mast_img").removeClass('active');
														jQuery("#first-mast").addClass('active');
													}

												}
												else
												{
													jQuery(".choose-type-label").removeClass('active');
													jQuery("#wind-zone-label").addClass('active');
													jQuery("#terrain-type-label").addClass('active');
													jQuery("#height-label").addClass('active');
													jQuery("#material-label").addClass('active');
													jQuery(".mast_img").removeClass('active');
													jQuery("#first-mast").addClass('active');
												}
											}
										});
										jQuery("#choose-mast-material").ddslick('select', { index: 0 });
										/*end material*/
									}
									else
									{
										jQuery(".choose-type-label").removeClass('active');
										jQuery("#wind-zone-label").addClass('active');
										jQuery("#terrain-type-label").addClass('active');
										jQuery("#height-label").addClass('active');
										jQuery(".mast_img").removeClass('active');
										jQuery("#first-mast").addClass('active');
									}
								}
							});
							jQuery("#choose-height").ddslick('select', { index: 0 });
							/*end hc*/
						}
						else
						{
							jQuery(".choose-type-label").removeClass('active');
							jQuery("#wind-zone-label").addClass('active');
							jQuery("#terrain-type-label").addClass('active');
							jQuery(".mast_img").removeClass('active');
							jQuery("#first-mast").addClass('active');
						}
					}
				});
				jQuery("#choose-height").ddslick('select', { index: 0 });
				/*end teren*/
			}
			else
			{
				jQuery(".choose-type-label").removeClass('active');
				jQuery("#wind-zone-label").addClass('active');
				jQuery(".mast_img").removeClass('active');
				jQuery("#first-mast").addClass('active');
			}

		}
	});

	jQuery(".welcome_row.about .col-12:nth-child(1) img").on("click", function()
	{
		jQuery(".welcome_row.about .col-12:nth-child(1) video").addClass("on");
		jQuery(".welcome_row.about .col-12:nth-child(1) video").get(0).muted = false;
		jQuery(".welcome_row.about .col-12:nth-child(1) video").get(0).play();


	});
	/*HIDE EMAIL*/

	jQuery('#page_id').each(function()
	{
		var $this = jQuery(this), numberOfOptions = jQuery(this).children('option').length;

		$this.addClass('select-hidden');
		$this.wrap('<div class="select"></div>');
		$this.after('<div class="select-styled"></div>');

		var $styledSelect = $this.next('div.select-styled');
		$styledSelect.text($this.children('option').eq(0).text());

		var $list = jQuery('<ul />', {
			'class': 'select-options'
		}).insertAfter($styledSelect);

		for (var i = 1; i < numberOfOptions; i++)
		{
			jQuery('<li />', {
				text: $this.children('option').eq(i).text(),
				rel: $this.children('option').eq(i).val()
			}).appendTo($list);
			//if ($this.children('option').eq(i).is(':selected')){
			//  $('li[rel="' + $this.children('option').eq(i).val() + '"]').addClass('is-selected')
			//}
		}

		var $listItems = $list.children('li');

		$styledSelect.click(function(e)
		{
			e.stopPropagation();
			jQuery('div.select-styled.active').not(this).each(function()
			{
				jQuery(this).removeClass('active').next('ul.select-options').hide();
			});
			jQuery(this).toggleClass('active').next('ul.select-options').toggle();
		});

		$listItems.click(function(e)
		{
			e.stopPropagation();
			$styledSelect.text(jQuery(this).text()).removeClass('active');
			$this.val(jQuery(this).attr('rel'));
			$list.hide();
			console.log($this.val());
			jQuery("#page_id").val($this.val());
			jQuery("#page_id_btn").trigger("click");
		});

		jQuery(document).click(function()
		{
			$styledSelect.removeClass('active');
			$list.hide();
		});

	});
	jQuery('#page_id2').each(function()
	{
		var $this = jQuery(this), numberOfOptions = jQuery(this).children('option').length;

		$this.addClass('select-hidden');
		$this.wrap('<div class="select"></div>');
		$this.after('<div class="select-styled"></div>');

		var $styledSelect = $this.next('div.select-styled');
		$styledSelect.text($this.children('option').eq(0).text());

		var $list = jQuery('<ul />', {
			'class': 'select-options2'
		}).insertAfter($styledSelect);

		for (var i = 0; i < numberOfOptions; i++)
		{
			jQuery('<li />', {
				text: $this.children('option').eq(i).text(),
				value: $this.children('option').eq(i).val()
			}).appendTo($list);
			//if ($this.children('option').eq(i).is(':selected')){
			//  $('li[rel="' + $this.children('option').eq(i).val() + '"]').addClass('is-selected')
			//}
		}

		var $listItems = $list.children('li');

		$styledSelect.click(function(e)
		{
			e.stopPropagation();
			jQuery('div.select-styled.active').not(this).each(function()
			{
				jQuery(this).removeClass('active').next('ul.select-options2').hide();
			});
			jQuery(this).toggleClass('active').next('ul.select-options2').toggle();
		});

		$listItems.click(function(e)
		{
			e.stopPropagation();
			jQuery(".product-category").removeClass('off');
			$styledSelect.text(jQuery(this).text()).removeClass('active');
			$this.val(jQuery(this).attr('value'));
			$list.hide();
			jQuery("#page_id2").val($this.val());
			let currentVal = jQuery(this).val();
			if (currentVal != 0)
			{
				jQuery(".mat-col").addClass("off");
				jQuery(".mat-th").addClass("off");
				jQuery(".material-id-" + currentVal).removeClass("off");
				jQuery(".mat-col.no-pdf").parent().addClass('off');
				jQuery(".product-category").each(function()
				{
					let thNumber = jQuery(this).find(".mat-th").length;
					let thNumberHidden = jQuery(this).find(".mat-th.off").length;
					if (thNumber == thNumberHidden)
					{
						jQuery(this).addClass("off");
					}
				});
			}
			else
			{
				jQuery(".product-category").removeClass('off');
				jQuery(".mat-col").removeClass("off");
				jQuery(".mat-th").removeClass("off");
				jQuery(".mat-col.no-pdf").parent().removeClass('off');
			}
		});

		jQuery(document).click(function()
		{
			$styledSelect.removeClass('active');
			$list.hide();
		});

	});


	jQuery("#page_id").on("change", function()
	{
		jQuery("#page_id_btn").trigger("click");
	});

	jQuery(".select-options").on("change", function()
	{
		jQuery("#page_id_btn").trigger("click");
	});

	jQuery(".categories_filter_reset_btn").on("click", function()
	{
		jQuery(".location_listing1 ").hide();
	});

	jQuery(".wpgmp_search_input ").on("keydown", function()
	{
		jQuery(".location_listing1 ").show();
	});

	jQuery('body').find('a:not(:has(*)):contains(@):not(script)').on('click', function()
	{
		let element = jQuery(this);
		let value = jQuery(this).text();
		let prefix = value.split('@')[ 0 ];
		setTimeout(function()
		{
			element.attr("href", "mailto:" + prefix + "@an-kom.pl");
			element.text(prefix + "@an-kom.pl");
		}, 500);
	});

	jQuery(".wpgmp_search_input").on("keydown", function()
	{
		jQuery(".location_listing1").css("display", "block");
	});

	/**CONVERTER START**/

	//HOOP IRON
	jQuery(".hoop_iron_params_wrapper > div:first-child").addClass('active');
	jQuery(".iron_hoop_img:first-child").addClass('active');
	jQuery('#choose-hoop-iron').ddslick({
		width: 500,
		background: "#fff",
		selectText: "Wybierz rodzaj bednarki",
		onSelected: function(selectedData)
		{
			let selectedValue = selectedData.selectedData.value;
			jQuery(".hoop_iron_params_wrapper .hoop_iron_params").removeClass('active');
			jQuery(".iron_hoop_img").removeClass('active');
			jQuery("#params-" + selectedValue).addClass('active');
			jQuery("#iron_hoop-" + selectedValue).addClass('active');
			jQuery("#hoop_iron_length").val('');
			jQuery("#final_weight").removeClass("active");
		}
	});

	jQuery('#hoop_iron_length').on('change keyup', function()
	{
		let thisValue = jQuery(this).val();
		let currentWeight = jQuery(".iron_hoop_img.active").find('.ratio-weight').text();
		let ratioDensity = jQuery(".hoop_iron_params.active").find('.ratio-density').attr('data-density');
		let finalWeight = thisValue * ratioDensity;
		let finalNumber = finalWeight / currentWeight;
		finalWeight = finalWeight.toFixed(2);
		finalNumber = Math.ceil(finalNumber);
		jQuery("#final_weight").addClass("active");
		jQuery("#final_weight").find("span").text(finalWeight);
	});

	// EARTH WIRE
	jQuery(".earth_wire_params_wrapper > div:first-child").addClass('active');
	jQuery(".earth_wire_img :first-child").addClass('active');
	jQuery('#choose-earth_wire').ddslick({
		width: 500,
		background: "#fff",
		selectText: "Wybierz rodzaj drutu odgromowego",
		onSelected: function(selectedData)
		{
			let selectedValue = selectedData.selectedData.value;
			jQuery(".earth_wire_params_wrapper .earth_wire_params").removeClass('active');
			jQuery(".earth_wire_img").removeClass('active');
			jQuery("#earth_wire_params-" + selectedValue).addClass('active');
			jQuery("#earth_wire-" + selectedValue).addClass('active');
			jQuery("#earth_wire_length").val('');
			jQuery("#earth_wire_final_weight").removeClass("active");
		}
	});

	jQuery('#earth_wire_length').on('change keyup', function()
	{
		let thisValue = jQuery(this).val();
		let currentWeight = jQuery(".earth_wire_img.active").find('.ratio-weight').text();
		let ratioDensity = jQuery(".earth_wire_params.active").find('.ratio-density').attr('data-density');
		let finalWeight = thisValue * ratioDensity;
		let finalNumber = finalWeight / currentWeight;
		finalWeight = finalWeight.toFixed(2);
		finalNumber = Math.ceil(finalNumber);
		jQuery("#earth_wire_final_weight").addClass("active");
		//	jQuery("#final_numb").addClass("active");
		jQuery("#earth_wire_final_weight").find("span").text(finalWeight);
		//	jQuery("#final_numb").find("span").text(finalNumber);
	});


	// EARTH CABLE
	jQuery(".earth_cable_params_wrapper > div:first-child").addClass('active');
	jQuery(".earth_cable_img :first-child").addClass('active');
	jQuery('#choose-earth_cable').ddslick({
		width: 500,
		background: "#fff",
		selectText: "Wybierz rodzaj linki odgromowej",
		onSelected: function(selectedData)
		{
			let selectedValue = selectedData.selectedData.value;
			jQuery(".earth_cable_params_wrapper .earth_cable_params").removeClass('active');
			jQuery(".earth_cable_img").removeClass('active');
			jQuery("#earth_cable_params-" + selectedValue).addClass('active');
			jQuery("#earth_cable-" + selectedValue).addClass('active');
			jQuery("#earth_cable_length").val('');
			jQuery("#earth_cable_final_weight").removeClass("active");
		}
	});

	jQuery('#earth_cable_length').on('change keyup', function()
	{
		let thisValue = jQuery(this).val();
		let currentWeight = jQuery(".earth_cable_img.active").find('.ratio-weight').text();
		let ratioDensity = jQuery(".earth_cable_params.active").find('.ratio-density').attr('data-density');
		let finalWeight = thisValue * ratioDensity;
		let finalNumber = finalWeight / currentWeight;
		finalWeight = finalWeight.toFixed(2);
		finalNumber = Math.ceil(finalNumber);
		jQuery("#earth_cable_final_weight").addClass("active");
		//	jQuery("#final_numb").addClass("active");
		jQuery("#earth_cable_final_weight").find("span").text(finalWeight);
		//	jQuery("#final_numb").find("span").text(finalNumber);
	});

	// GLUE

	jQuery(".glue_params_wrapper > div:first-child").addClass('active');
	jQuery(".glue_img :first-child").addClass('active');
	jQuery('#choose-glue').ddslick({
		width: 500,
		background: "#fff",
		selectText: "Wybierz rodzaj linki odgromowej",
		onSelected: function(selectedData)
		{
			let selectedValue = selectedData.selectedData.value;
			jQuery(".glue_params_wrapper .glue_params").removeClass('active');
			jQuery(".glue_img").removeClass('active');
			jQuery("#glue_params-" + selectedValue).addClass('active');
			jQuery("#glue-" + selectedValue).addClass('active');
			jQuery("#glue_length").val('');
			jQuery("#glue_final_weight").removeClass("active");
		}
	});

	jQuery('#glue_length').on('change keyup', function()
	{
		let thisValue = jQuery(this).val();
		let currentWeight = jQuery(".glue_img.active").find('.ratio-weight').text();
		let ratioDensity = jQuery(".glue_params.active").find('.ratio-density').attr('data-density');
		let finalWeight = thisValue * ratioDensity;
		let finalNumber = finalWeight / currentWeight;
		finalWeight = finalWeight / currentWeight;
		finalWeight = Math.ceil(finalWeight);
		//	finalNumber = Math.ceil(finalNumber);
		jQuery("#glue_final_weight").addClass("active");
		//	jQuery("#final_numb").addClass("active");
		jQuery("#glue_final_weight").find("span").text(finalWeight);
		//	jQuery("#final_numb").find("span").text(finalNumber);
	});




	/**CONVERTER END**/

	if (jQuery('body').hasClass('page-template-download'))
	{
		let link = location.hash;
		if (link != '')
		{
			setTimeout(function() { jQuery(link).find('.heading').trigger('click'); }, 200);
			jQuery([ document.documentElement, document.body ]).animate({
				scrollTop: jQuery(link).offset().top - 100
			}, 2000);
		}
	}

	jQuery(document).keyup(function(e)
	{
		if (e.key === "Escape")
		{
			jQuery('.preview-bg').removeClass('on');
		}
	});

	function setCookie(name, value, days)
	{
		var expires = "";
		if (days)
		{
			var date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "") + expires + "; path=/";
	}
	function getCookie(cname)
	{
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++)
		{
			var c = ca[ i ];
			while (c.charAt(0) == ' ')
			{
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0)
			{
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}
	let browserWidth = jQuery(window).width();
	let alertsHeight = jQuery('.alerts').outerHeight();
	jQuery(".home .alerts-header").css("top", alertsHeight);
	if (browserWidth >= 1008)
	{
		jQuery("html:not(.product-preview)  body:not(.home)").css("padding-top", alertsHeight + 160);
	}
	else if (browserWidth < 1008 && browserWidth >= 464)
	{
		jQuery("html:not(.product-preview)  body:not(.home)").css("padding-top", alertsHeight + 105);
	}
	else
	{
		jQuery("html:not(.product-preview)  body:not(.home)").css("padding-top", alertsHeight + 80);
	}
	jQuery("html:not(.product-preview) body:not(.home) .alerts-header").css("top", alertsHeight);
	jQuery(".close-alert").on("click", function()
	{
		let cookie = jQuery(this).parent().attr('id');
		console.log(cookie);
		setCookie(cookie, true, 30);
		jQuery(this).parent().remove();
		let alertsHeight = jQuery('.alerts').outerHeight();
		jQuery(".home .alerts-header").css("top", alertsHeight);
		if (browserWidth >= 1008)
		{
			jQuery("html:not(.product-preview)  body:not(.home)").css("padding-top", alertsHeight + 160);
		}
		else if (browserWidth < 1008 && browserWidth >= 464)
		{
			jQuery("html:not(.product-preview)  body:not(.home)").css("padding-top", alertsHeight + 105);
		}
		else
		{
			jQuery("html:not(.product-preview)  body:not(.home)").css("padding-top", alertsHeight + 80);
		}
		jQuery("body:not(.home) .alerts-header").css("top", alertsHeight);
	});

	reloadClipboard();
	jQuery(".gallery-icon > a").each(function()
	{
		jQuery(this).addClass("fancybox");
		jQuery(this).attr("rel", "gallery-0");
	});

	jQuery.fn.autoComplete.defaults = {
		source: 0,
		minChars: 3,
		delay: 150,
		cache: 1,
		menuClass: '',
		renderItem: function(item, search)
		{
			// escape special characters
			search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
			var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
			return '<div class="autocomplete-suggestion" data-val="' + item.title + '">' + item.title.toString().replace(re, "<b>$1</b>") + '</div>';
		},
		onSelect: function(e, term, item) { }
	};
	var getUrl = window.location;
	var baseUrl = getUrl.protocol + "//" + getUrl.host + "/";
	var currentRequest = null;
	jQuery('.search-field').autoComplete({
		minChars: 3,
		source: function(term, suggest)
		{
			currentRequest = jQuery.ajax({
				dataType: 'json',
				url: baseUrl + '/wp-json/v1/products/search?s=' + term,
				type: 'GET',
				beforeSend: function(xhr)
				{
					if (currentRequest != null)
					{
						currentRequest.abort();
					}
				},
				error: function(xhr, status, error)
				{
				},
				success: function(data)
				{
					suggest(data);
				}
			});
		},
	});

	jQuery('.home__slider .to-slick').slick({
		draggable: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		prevArrow: '<i class="arrow_carrot-left arrow-left"></i>',
		nextArrow: '<i class="arrow_carrot-right arrow-right"></i>',
		dots: true,
		lazyLoad: 'ondemand',
		speed: 900,
		infinite: true,
		autoplay: false,
		adaptiveHeight: true,
		pauseOnHover: true,
		autoplaySpeed: 7000,
		customPaging: function(slider, i)
		{
			return ("0" + (i + 1));
		}
	});
	jQuery("#fancybox-prev").on('click', function()
	{
		let current = jQuery(".slick-slide.slick-active");
		current.prev().addClass('slick-active');
		let currentNumber = parseInt(current.attr('data-slick-index'));
		current.removeClass('slick-active');

		jQuery('.single-product-slick-wrapper').slick('slickGoTo', currentNumber - 1);
	});
	jQuery("#fancybox-next").on('click', function()
	{
		let current = jQuery(".slick-slide.slick-active");
		current.next().addClass('slick-active');
		let currentNumber = parseInt(current.attr('data-slick-index'));
		current.removeClass('slick-active');

		jQuery('.single-product-slick-wrapper').slick('slickGoTo', currentNumber + 1);

	});

	jQuery('.single-product-slick-wrapper').slick({
		draggable: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		prevArrow: '<i class="arrow_carrot-left arrow-left"></i>',
		nextArrow: '<i class="arrow_carrot-right arrow-right"></i>',
		dots: true,
		lazyLoad: 'ondemand',
		speed: 900,
		infinite: false,
		autoplay: false,
		adaptiveHeight: true,
		pauseOnHover: true,
		autoplaySpeed: 7000,
		focusOnSelect: false,
		customPaging: function(slider, i)
		{
			let link = jQuery(slider.$slides[ i ]).attr('href');
			link = link.split(/[#?]/)[ 0 ].split('.').pop().trim();
			if (link == 'mp4')
			{
				return '<button><span class="thumbImg video-thumbnail"></span></button>';
			}
			else
			{
				return '<button><span class="thumbImg" style="background-image:url(' + jQuery(slider.$slides[ i ]).attr('href') + ');"></span></button>';
			}
		},
	});

	jQuery(window).resize(function()
	{
		/*jQuery('.single-product-slick-wrapper').slick('unslick');
			jQuery('.single-product-slick-wrapper').slick({
			draggable: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			prevArrow: '<i class="arrow_carrot-left arrow-left"></i>',
			nextArrow: '<i class="arrow_carrot-right arrow-right"></i>',
			dots:true,
			lazyLoad: 'ondemand',
			speed: 900,
			infinite: false,
			autoplay: false,
			adaptiveHeight: true,
			pauseOnHover:true,
			autoplaySpeed: 7000,
			focusOnSelect: false,
			 customPaging: function(slider, i) {
						let link = jQuery(slider.$slides[i]).attr('href');
						link = link.split(/[#?]/)[0].split('.').pop().trim();
						if(link =='mp4'){
							  return '<button><span class="thumbImg video-thumbnail"></span></button>';
						}
						else{
							return '<button><span class="thumbImg" style="background-image:url('+jQuery(slider.$slides[i]).attr('href')+');"></span></button>';
						}
					},
		});*/

	});

	jQuery('.slick-wrp').slick({
		draggable: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		prevArrow: '<i class="arrow_carrot-left arrow-left"></i>',
		nextArrow: '<i class="arrow_carrot-right arrow-right"></i>',
		dots: true,
		lazyLoad: 'ondemand',
		speed: 900,
		infinite: true,
		autoplay: false,
		adaptiveHeight: true,
		pauseOnHover: true,
		autoplaySpeed: 7000,
		customPaging: function(slider, i)
		{
			return '<button><span class="thumbImg" style="background-image:url(' + jQuery(slider.$slides[ i ]).attr('href') + ');"></span></button>';
		},
	});

	jQuery(".close-link-360").click(function()
	{
		jQuery('.popup-360').removeClass('on');
	});

	/*   let rotateList = document.querySelector(".rotate-list");
	   let images = jQuery(".rotate-list li");
	   let imageCount = images.length;
	   if(document.querySelector(".rotate-list")){
	   // Initially, only the first image is visible
	   let currentImageIndex = 0;
	   images[currentImageIndex].classList.add = 'active';

	   rotateList.addEventListener("mousemove", function(event) {
		   // Get the mouse position relative to the element
		   let rect = rotateList.getBoundingClientRect();
		   let xPos = event.clientX - rect.left;

		   // Calculate the percentage of the mouse position relative to the element's width
		   let percentage = xPos / rect.width;
		   console.log("imageCount" + imageCount);


		   // Calculate the image index to display based on the mouse position
		   let imageIndex = Math.floor(percentage * imageCount);
		   console.log("wybrane: " + imageIndex);
		   // If the calculated image index is different from the current one, update it
		   if (imageIndex !== currentImageIndex) {
			   // Hide the current image
			   jQuery(".rotate-list li").removeClass('active');
			   jQuery(".rotate-list li").eq(imageIndex).addClass('active');

			   // Update the current image index
			   currentImageIndex = imageIndex;
		   }
	   });
	   }*/
	if (document.getElementById('threesixty'))
	{
		let imageArray = [];
		let imgCount = 0;
		jQuery("#threesixty li img").each(function()
		{
			imageArray.push(jQuery(this).attr('src'));
			imgCount++;
		});
		const threesixty = new ThreeSixty(document.getElementById('threesixty'), {
			image: imageArray,
			width: 800,  // Image width. Default 300
			dragTolerance: 12,  // Rotation speed when dragging. Default: 10
			swipeTolerance: 12, // Rotation speed when swiping. Default: 10
			height: 700, // Image height. Default 300
			speed: 200,
			count: imgCount,                   // Total number of images. Default: 0

		});
	}
	//	threesixty.play();

	jQuery("#rotate-input").on('input change', function(event)
	{
		let thisValue = jQuery(this).val();
		jQuery('.rotate-list li').removeClass('active');
		jQuery('.rotate-list li').eq(thisValue - 1).addClass('active');
	});


	initProductScript();

	initContactScript();

	jQuery('.home__partners .to-slick').slick({
		draggable: true,
		slidesToShow: 3,
		slidesToScroll: 3,
		rows: 2,
		slidesPerRow: 1,
		lazyLoad: 'ondemand',
		arrows: true,
		prevArrow: '<i class="arrow_carrot-left arrow-left"></i>',
		nextArrow: '<i class="arrow_carrot-right arrow-right"></i>',
		dots: false,
		speed: 900,
		infinite: true,
		autoplay: true,
		adaptiveHeight: true,
		autoplaySpeed: 7000,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					arrows: false
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					arrows: false,
					slidesToScroll: 2
				}
			}
		]
	});

	jQuery('.home__offer .section-desc h3').on("click", function(e)
	{
		let slideIndex = jQuery(this).attr("data-hover");
		jQuery('.home__offer .to-slick').slick('slickGoTo', parseInt(slideIndex), false);
	});
	jQuery('.home__offer .to-slick').on('afterChange', function()
	{
		let slideIndex = parseInt(jQuery('.home__offer .slick-current').attr("data-slick-index"));
		jQuery(".home__offer .section-desc .categories h3").removeClass("on");
		jQuery(".home__offer .section-desc .categories h3").eq(slideIndex).addClass("on");
	});

	jQuery('.home__offer .to-slick').slick({
		draggable: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		prevArrow: '<i class="arrow_carrot-left arrow-left"></i>',
		nextArrow: '<i class="arrow_carrot-right arrow-right"></i>',
		dots: false,
		speed: 900,
		lazyLoad: 'ondemand',
		infinite: true,
		autoplay: true,
		adaptiveHeight: true,
		autoplaySpeed: 7000,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					arrows: true
				}
			}
		]
	});

	jQuery('#job_offer .to-slick').slick({
		draggable: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		prevArrow: '<i class="arrow_carrot-left arrow-left"></i>',
		nextArrow: '<i class="arrow_carrot-right arrow-right"></i>',
		dots: false,
		speed: 900,
		fade: true,
		infinite: false,
		autoplay: false,
		adaptiveHeight: true,
		autoplaySpeed: 7000,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					arrows: true
				}
			}
		]
	});
	let slideIndex = parseInt(jQuery('.home__offer .slick-current').attr("data-slick-index"));
	jQuery(".home__offer .section-desc .categories h3").removeClass("on");
	jQuery(".home__offer .section-desc .categories h3").eq(slideIndex).addClass("on");
	jQuery("#show_search").on("click", function()
	{
		jQuery(".search_form").toggle('fast');
		jQuery(".header .search_form .search-field").focus();
	});
	jQuery(".toggle-clipboard").on("click", function()
	{
		jQuery(".clipboard").toggleClass('on');
	});
	jQuery('#popup-360').click(function(e)
	{
		if (!jQuery(e.target).closest('.popup-360-wrapper').length && !jQuery(e.target).closest('.show-popup-360').length)
		{
			jQuery("#popup-360").removeClass('on');
		}
	});
	jQuery('.page-content, header').click(function(e)
	{
		if (!jQuery(e.target).closest('.clipboard').length && !jQuery(e.target).closest('.toggle-clipboard').length)
		{
			jQuery(".clipboard").removeClass('on');
		}
		if (!jQuery(e.target).closest('.search_form').length && !jQuery(e.target).closest('#show_search').length && !jQuery(e.target).closest('.autocomplete-suggestions').length && !jQuery(e.target).closest('.autocomplete-suggestion').length)
		{
			jQuery(".search_form").hide('fast');
		}

	});
	jQuery(".close-link").on("click", function()
	{
		jQuery(".preview-bg").toggleClass('on', 'slow');
	});

	var my_repeater_more = true;

	jQuery("#gallery-load-more").on("click", function()
	{
		var my_repeater_field_post_id = jQuery(this).attr("my_repeater_field_post_id");
		var my_repeater_field_offset = jQuery(this).attr("my_repeater_field_offset");
		var my_repeater_field_nonce = jQuery(this).attr("my_repeater_field_nonce");
		var my_repeater_ajax_url = jQuery(this).attr("my_repeater_ajax_url");
		jQuery.post(
			my_repeater_ajax_url, {
			'action': 'my_repeater_show_more',
			'post_id': my_repeater_field_post_id,
			'offset': my_repeater_field_offset,
			'nonce': my_repeater_field_nonce
		},
			function(json)
			{
				jQuery('.team_row .team').append(json[ 'content' ]);
				my_repeater_field_offset = json[ 'offset' ];
				if (!json[ 'more' ])
				{
					jQuery('#gallery-load-more').css('display', 'none');
				}
			},
			'json'
		);
	});
	jQuery(".c-download > a").on("click", function(e)
	{
		e.preventDefault();

		var clipboardData = JSON.parse(localStorage.getItem("clipboard") || "[]");

		if (clipboardData.length === 0)
		{
			alert("Schowek jest pusty.");
			return;
		}

		var zip = new JSZip();
		var folder = zip.folder("schowek");
		var downloadCount = 0;

		clipboardData.forEach(function(item, index)
		{
			var url = item.url;
			if (!url) return;

			console.log("Downloading file:", url);

			// Pobierz nazwę pliku z URL
			var fileNameFromPath = url.split("/").pop().split("?")[ 0 ].split("#")[ 0 ];

			if (!fileNameFromPath)
			{

				if (item.title)
				{
					item.title = item.title.replace(/\s+/g, '_');
					item.title = item.title.replace('-_', '');
				}

				fileNameFromPath = item.title ? item.title : 'file_' + index;
				fileNameFromPath += '.pdf';
			}

			console.log("Final filename:", fileNameFromPath);

			JSZipUtils.getBinaryContent(url, function(err, data)
			{
				downloadCount++;
				if (err)
				{
					console.error("Nie udało się pobrać pliku:", url, err);
				} else
				{
					folder.file(fileNameFromPath, data, { binary: true });
				}

				// Gdy wszystkie pliki zostały przetworzone
				if (downloadCount === clipboardData.length)
				{
					zip.generateAsync({ type: "blob" }).then(function(content)
					{
						saveAs(content, "schowek.zip");
					});
				}
			});
		});
	});



	jQuery(".single-print-pdf").on("click", function(e)
	{
		document.getElementById("single-pdf-print").contentWindow.print();
	});

	jQuery(".show-preview").on("click", function(e)
	{
		let thisHref = jQuery(this).attr("data-href");
		let thisPdf = jQuery(this).attr("data-pdf");
		let thisPDFLink = jQuery(this).attr("data-pdf-link");
		let thisName = jQuery(this).attr("data-name");
		let thisFavorite = jQuery(this).attr("data-favorite");
		let thisFavoriteId = jQuery(this).attr("data-favorite-id");
		let thisSingleHref = jQuery(this).attr("data-single-href");
		document.getElementById('preview-ifr').contentDocument.location.replace(thisHref);
		document.getElementById('previewpdf-ifr').contentDocument.location.replace(thisPdf);
		jQuery(".preview-bg .pdf-link").attr("href", thisPdf);
		jQuery(".preview-bg .print-pdf").attr("data-href", thisPdf);
		jQuery(".preview-bg .favorite-link").attr("data-favorite", thisFavorite);
		jQuery(".preview-bg .favorite-link").attr("data-favorite-id", thisFavoriteId);
		jQuery(".preview-bg .favorite-link").attr("data-href", thisPDFLink);
		jQuery(".preview-bg .favorite-link").attr("data-name", thisName);
		jQuery(".preview-bg .see-single-page").attr("href", thisSingleHref);
		setTimeout(function()
		{
			jQuery(".preview-bg").toggleClass('on', 'slow');
		}, 500);
	});
	jQuery(".print-pdf").on("click", function(e)
	{
		let thisHref = jQuery(this).attr("data-href");
		document.getElementById("previewpdf-ifr").contentWindow.print();
	});

	jQuery(".favorite-link, .single-favorite, .add-to-clipboard").on("mouseout", function(e)
	{
		jQuery(this).removeClass("off").addClass("off");
	});

	function reloadClipboard()
	{
		const clipboard = JSON.parse(localStorage.getItem('clipboard')) || [];
		let clipboardContainer = jQuery(".clipboard .c-content");
		clipboardContainer.html('');
		let clipboardLength = clipboard.length;
		let clipboardLink = jQuery(".clipboard").attr("data-clipboard");
		jQuery(".clipboard-counter").text(clipboardLength);

		clipboard.forEach(function(val)
		{
			let title = val.title || val.filename;
			let symbol = val.symbol || '';
			let file = `
			<div class='single-file'>
				<div class='title'><strong>${title}</strong><br>${symbol}</div>
				<div class='type ${val.type}'><a href="${val.url}" download rel="noopener noreferrer"></a></div>
				<div class='remove'>
					<a data-favorite-id="${val.id}"></a>
				</div>
			</div>`;
			clipboardContainer.append(file);
		});

		jQuery(".clipboard .remove a").on("click", function()
		{
			let actionId = jQuery(this).attr("data-favorite-id");
			let element = jQuery(this);
			removeFromClipboard(actionId, element);
		});
	}

	//let clipboardLock = false;
	function addToClipboard(actionId, element, fileData)
	{
		//if (clipboardLock) return; // Blokada aktywna — ignoruj kliknięcie
		//clipboardLock = true;

		let clipboard = JSON.parse(localStorage.getItem('clipboard')) || [];

		let exists = clipboard.some(item => item.id == actionId);
		if (exists)
		{
			jQuery(".added-to-clipboard-notice").removeClass("on");
			jQuery(".added-to-clipboard-notice-already").addClass("on");

			setTimeout(() =>
			{
				jQuery(".added-to-clipboard-notice").removeClass("on");
				jQuery(".added-to-clipboard-notice-already").removeClass("on");
				//	clipboardLock = false; // Zwolnij blokadę
			}, 2500);
			return;
		}

		clipboard.push({
			id: actionId,
			title: fileData.title || fileData.filename,
			filename: fileData.filename || '',
			symbol: fileData.symbol || '',
			type: fileData.type || '',
			url: fileData.url || ''
		});

		localStorage.setItem('clipboard', JSON.stringify(clipboard));
		reloadClipboard();

		jQuery(element).removeClass("off");

		setTimeout(() =>
		{
			jQuery(".added-to-clipboard-notice").addClass("on");
			jQuery(".added-to-clipboard-notice-already").removeClass("on");
		}, 500);

		setTimeout(() =>
		{
			jQuery(".added-to-clipboard-notice").removeClass("on");
			jQuery(".added-to-clipboard-notice-already").removeClass("on");
			clipboardLock = false; // Zwolnij blokadę po zakończeniu animacji
		}, 2500);
	}



	function removeFromClipboard(actionId, element)
	{
		let clipboard = JSON.parse(localStorage.getItem('clipboard')) || [];
		clipboard = clipboard.filter(item => item.id != actionId);
		localStorage.setItem('clipboard', JSON.stringify(clipboard));

		if (jQuery(".clipboard").hasClass("on"))
		{
			setTimeout(() =>
			{
				jQuery(".clipboard").addClass("on");
			}, 50);
		}

		reloadClipboard();
	}



	jQuery(".favorite-link").on("click", function(e)
	{
		e.preventDefault();

		let element = jQuery(this);
		let actionId = element.attr("data-favorite-id");
		let title = element.attr("data-name") || "Nieznany tytuł";
		let url = element.attr("data-href") || "#";
		let type = element.attr("data-extension") || "unknown";
		let symbol = ""; // Jeśli chcesz dodać symbol osobno, można rozszerzyć HTML

		let fileData = {
			title: title,
			symbol: symbol,
			type: type,
			url: url,
			filename: title
		};

		addToClipboard(actionId, element, fileData);
	});

	jQuery(".clear-clipboard").on("click", function(e)
	{
		e.preventDefault();

		// Wyczyść localStorage
		localStorage.removeItem("clipboard");

		// Odśwież widok schowka
		let clipboardLink = jQuery('.clipboard').attr('data-clipboard');
		reloadClipboard();
	});

	jQuery(".single-favorite").on("click", function(e)
	{
		e.preventDefault();

		let element = jQuery(this);
		let actionId = element.attr("data-favorite-id");
		let title = element.attr("data-name") || "Nieznany tytuł";
		let url = element.attr("data-href") || "#";
		let type = element.attr("data-extension") || "unknown";
		let symbol = ""; // Jeśli chcesz dodać symbol osobno, można rozszerzyć HTML

		let fileData = {
			title: title,
			symbol: symbol,
			type: type,
			url: url,
			filename: title
		};

		addToClipboard(actionId, element, fileData);
	});

	jQuery(".add-to-clipboard").on("click", function(e)
	{
		e.preventDefault();
		e.stopPropagation();

		let element = jQuery(this);
		let actionId = element.attr("data-favorite-id");
		let title = element.attr("data-name") || "Nieznany tytuł";
		let url = element.attr("data-href") || "#";
		let type = element.attr("data-extension") || "unknown";
		let symbol = ""; // Jeśli chcesz dodać symbol osobno, można rozszerzyć HTML

		let fileData = {
			title: title,
			symbol: symbol,
			type: type,
			url: url,
			filename: title
		};

		addToClipboard(actionId, element, fileData);
	});


	jQuery(".product_groups.grey-bg .product-group .inner-box").hover(function()
	{
		let color = jQuery(this).attr("data-color");
		jQuery(this).find(".bg-span").css("background", color);
	}, function()
	{
		jQuery(this).find(".bg-span").css("background", '#f6f6f6');
	});

	jQuery(".product_groups.parent-bg .product-group .inner-box").hover(function()
	{
		let color = jQuery(this).attr("data-color");
		jQuery(this).find(".bg-span").css("background", color);
	}, function()
	{
		jQuery(this).find(".bg-span").css("background", '#f6f6f6');
	});
	jQuery(".department .heading").on("click", function()
	{
		let hadClass = jQuery(this).hasClass("in");
		jQuery(".department .heading").removeClass("in");
		jQuery(".department .heading").next().hide("slow");
		if (!hadClass)
		{
			jQuery(this).next().slideToggle();
			jQuery(this).toggleClass("in");
		}
	});
	jQuery(".download > .heading").on("click", function()
	{
		let hadClass = jQuery(this).hasClass("in");
		jQuery(".download > .heading").removeClass("in");
		jQuery(".download > .heading").next().hide("slow");

		if (hadClass === true)
		{
			jQuery(".download > .heading").next().find(".download-cat > .heading").each(function(index, element)
			{
				jQuery(element).removeClass("in");
				jQuery(element).next().hide("slow");
			});
		}

		if (!hadClass)
		{
			jQuery(this).next().slideToggle();
			jQuery(this).toggleClass("in");
		}
	});
	jQuery(".download-cat > .heading").on("click", function()
	{
		let hadClass = jQuery(this).hasClass("in");
		jQuery(this).removeClass("in");
		jQuery(this).next().hide("slow");

		if (hadClass === true)
		{
			jQuery(this).next().find(".download-cat > .heading").each(function(index, element)
			{
				jQuery(element).removeClass("in");
				jQuery(element).next().hide("slow");
			});
		}

		if (!hadClass)
		{
			jQuery(this).next().slideToggle();
			jQuery(this).toggleClass("in");
		}
	});

	jQuery(".search_row .search-result .heading").on("click", function()
	{
		let hadClass = jQuery(this).hasClass("in");
		jQuery(".search-result .heading").removeClass("in");
		jQuery(".search-result .heading").next().hide("slow");
		if (!hadClass)
		{
			jQuery(this).next().slideToggle();
			let browserWidth = jQuery(window).width();
			let thisElem = jQuery(this);
			if (browserWidth < 1008)
			{
				setTimeout(function()
				{
					jQuery('html, body').animate({
						scrollTop: thisElem.next().offset().top - 60
					}, 500);
				}, 500);
			}
			jQuery(this).toggleClass("in");
		}
	});

	jQuery(".converter .heading").on("click", function()
	{
		let hadClass = jQuery(this).hasClass("in");
		jQuery(".converter .heading").removeClass("in");
		jQuery(".converter .heading").next().hide("slow");
		if (!hadClass)
		{
			jQuery(this).next().slideToggle({
				duration: 300,
				easing: "easeOutQuad",
				start: function()
				{
					jQuery(this).css('display', 'flex');
				}
			});
			jQuery(this).toggleClass("in");
		}
	});

	jQuery('.hamburger').on('click', function()
	{
		jQuery(this).toggleClass('open-h');
		jQuery('.mobile-overlay').toggleClass('small-h');
	});

	jQuery('.sidebar-hamburger').on('click', function()
	{
		jQuery(this).toggleClass('open-h');
		jQuery('.sidebar').toggleClass('small-h');
	});

	jQuery('.offer-main-row .parent-item').on('click', function()
	{
		jQuery('.offer-main-row .parent-item').removeClass('active');
		jQuery(this).toggleClass('active');
	});

	jQuery('.archive-offer-main-row .parent-item').on('click', function()
	{
		//		jQuery('.archive-offer-main-row .parent-item').removeClass('active');
		//jQuery(this).toggleClass('active');
	});

	jQuery('.contact_us_row.cv input[type="file"]').bind('change', function()
	{
		var fileName = '';
		fileName = jQuery(this).val().replace(/C:\\fakepath\\/i, '');
		jQuery('#file-selected').html(fileName);
	});

	jQuery(".first-map").on("click", function()
	{
		jQuery(this).addClass("active");
		jQuery('.second-map').removeClass("active");
		jQuery('.places-one').addClass("active");
		jQuery('.places-two').removeClass("active");
	});

	jQuery(".second-map").on("click", function()
	{
		jQuery(this).addClass("active");
		jQuery('.first-map').removeClass("active");
		jQuery('.places-two').addClass("active");
		jQuery('.places-one').removeClass("active");
	});


	// MENU FIXED
	if (jQuery('header').length)
	{
		var scrollTrigger = 100, // px
			nagFix = function()
			{
				var scrollTop = jQuery(window).scrollTop();
				if (scrollTop > scrollTrigger)
				{
					jQuery('.header').addClass('header--small', 1000, "easeOutBounce");
				} else
				{
					jQuery('.header').removeClass('header--small', 1000, "easeOutBounce");
				}
			};
		nagFix();
		jQuery(window).on('scroll', function()
		{
			nagFix();
		});
	};
	let windowWidth = jQuery(window).width();
	let navigationWidth = jQuery(".slick-dots").width();
	let arrowRightPos, arrowLeftPos;
	if (windowWidth >= 1244)
	{
		arrowRightPos = ((jQuery(".page-content").width() - 1200) / 2) - 9 + navigationWidth;
		arrowLeftPos = ((jQuery(".page-content").width() - 1200) / 2) - 9 + navigationWidth + 20;
	}
	else
	{
		arrowRightPos = 15 + navigationWidth;
		arrowLeftPos = 15 + navigationWidth + 30;
	}
	jQuery(".home__slider .arrow-right").css("right", arrowRightPos);
	jQuery(".home__slider .arrow-left").css("right", arrowLeftPos);
	jQuery(".scroll-down-arrow").on("click", function(e)
	{
		e.preventDefault();
		jQuery("html, body").animate({ scrollTop: jQuery(".home__about").offset().top - 70 }, 600);
	});

});


if (document.getElementById("mobile-overlay"))
{
	let menuLink = document.getElementById("mobile-overlay").querySelectorAll(".menu-item-has-children > a");
	for (let i = 0, len = menuLink.length; i < len; i++)
	{
		let link = menuLink[ i ].getAttribute("href");
		menuLink[ i ].setAttribute("data-href", link);
		menuLink[ i ].setAttribute("href", "#");
		menuLink[ i ].classList.add("show-submenu");
		menuLink[ i ].addEventListener("click", function()
		{
			jQuery("#mobile-overlay .menu-item-has-children .sub-menu").css('display', 'none');
			this.nextElementSibling.style.display = 'block';
			setTimeout(function()
			{
				menuLink[ i ].setAttribute("href", link);
			}, 300);
		});
	}

}
